<template>
  <b-form @submit.prevent="submit">
    <b-row>
      <b-col md="6" lg="4">
        <b-form-group :label="$t('FIRST_NAME')">
          <b-form-input @change="updateFirstname" type="text" :value="user.first_name" :disabled="disabled"></b-form-input>
        </b-form-group>
      </b-col>
      <b-col md="6" lg="4">
        <b-form-group :label="$t('LAST_NAME')">
          <b-form-input @change="updateLastname" type="text" :value="user.last_name" :disabled="disabled"></b-form-input>
        </b-form-group>
      </b-col>
      <b-col md="6" lg="4">
        <b-form-group :label="$t('EMAIL')">
          <b-form-input @change="updateEmail" type="email" :value="user.email" :disabled="disabled"></b-form-input>
        </b-form-group>
      </b-col>
      <b-col md="6" lg="4">
        <b-form-group :label="$t('LANGUAGE')">
          <b-form-select @change="updateLanguage" id="basicLanguage"
                         :options="language_options"
                         :value="user.preferred_language">
          </b-form-select>
        </b-form-group>
      </b-col>
      <b-col md="6" lg="4" >
        <b-form-group :label="$t('TOOLTIPE')">
         <b-form-select @change="updateTooltipe"
                       :options="options_tooltipe"
                       :value="user.tooltipe">
          </b-form-select>
        </b-form-group>
      </b-col>
      <b-col md="6" lg="4" >
        <b-form-group :label="$t('MONTHLY_REMINDER')">
          <b-form-select @change="updateReminder"
                         :options="options_tooltipe"
                         :value="user.reminder">
          </b-form-select>
        </b-form-group>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <app-button-submit :loading="loading" :c_permission="C_USER_SAVE_BUTTON"></app-button-submit>
      </b-col>
    </b-row>
  </b-form>
</template>

<script>
  import {toast} from '@/shared/plugins/toastr'
  import {getErrorMessage} from '@/mixins/error/getErrorMessage'
  import AppButtonSubmit from '@/components/app/AppSubmit'
  import DatePicker from '@/components/app/datetime/DatePicker'
  import {C_USER_SAVE_BUTTON} from '@/shared/component_permission'
  import i18n from '@/locale/index'

    export default {
      name: "user-basic-form",
      mixins: [getErrorMessage],
      data() {
        return{
          options_tooltipe:[
            {value:1, text: i18n.t('ACTIVE')},
            {value:0, text: i18n.t('NOTACTIVE')}
          ],
          disabled: true,
          language_options:[
            {
              value:'en',text:this.$t('ENGLISH'),
            },
            {
              value:'sr',text:this.$t('SERBIAN'),
            },
            {
              value:'bs',text:this.$t('BOSNIAN_BOS'),
            },
            {
              value:'hr',text:this.$t('BOSNIAN_HRV'),
            },
            {
              value:'sr_ba',text:this.$t('BOSNIAN_SRP'),
            },
            {
              value:'mk',text:this.$t('MACEDONIAN'),
            },
            {
              value:'al',text:this.$t('ALBANIAN'),
            },
            {
              value:'mn',text:this.$t('MONTENEGRO'),
            }
          ],
          loading:false,
          C_USER_SAVE_BUTTON
        }
      },
      components: {
        AppButtonSubmit, DatePicker
      },
      computed: {
        languages() {
          return Object.keys(this.$i18n.messages)
        },
        user() {
          return this.$store.getters['user/getUser']
        },
      },
      methods:{
        updateEmail(value) {
          this.$store.dispatch('user/actionSetUserItem', {path: 'userData.email', value: value})
        },
        updateFirstname(value) {
          this.$store.dispatch('user/actionSetUserItem', {path: 'userData.first_name', value: value})
        },
        updateLastname(value) {
          this.$store.dispatch('user/actionSetUserItem', {path: 'userData.last_name', value: value})
        },
        updateTooltipe(value) {
          this.$store.dispatch('user/actionSetUserItem', {path: 'userData.tooltipe', value: value})
        },
        updateLanguage(value) {
          this.$store.dispatch('user/actionSetUserItem', {path: 'userData.preferred_language', value: value})
        },
        updateReminder(value){
          this.$store.dispatch('user/actionSetUserItem', {path: 'userData.reminder', value: value})
        },
        submit() {
          let data = {
            first_name: this.user.first_name,
            last_name:this.user.last_name,
            email:this.user.email,
            institution:this.user.institution,
            preferred_language:this.user.preferred_language,
            tooltipe:this.user.tooltipe,
            reminder:this.user.reminder,
          }
          this.loading = true
          this.$store.dispatch('user/actionUpdateUser', {id: this.user.id, data }).then(() => {
              toast({
                title: this.$t('NOTIFICATIONS.SAVE_SUCCESS.TITLE'),
                message: this.$t('NOTIFICATIONS.SAVE_SUCCESS.MESSAGE'),
                type: 'success',
                timeout: 3000
              })
            },
            error => {
              toast({
                title: this.$t('NOTIFICATIONS.SAVE_ERROR.TITLE'),
                message: this.$t('NOTIFICATIONS.SAVE_ERROR.MESSAGE', {value: this.getMessages(error)}),
                type: 'error',
                timeout: 6000
              })
            }).finally(()=>{
              this.loading = false
          })
        }
      }
    }
</script>

<style scoped>

</style>
